import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {ComponentFactoryResolver, EventEmitter, Injectable} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FuseSplashScreenService} from '@barebone-fuse/@fuse/services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {take} from 'rxjs/operators';
import {Router} from "@angular/router";
import {SnackBarService} from "@core/services/snack-bar.service";

@Injectable({
  providedIn: 'root',
})
export class AddPresetCountriesCommandHandler implements IPlatformCommandHandler {
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  invalidateSubject: InvalidateSubject = new InvalidateSubject();
  private selectedTabModel: TabModel;

  constructor(private dialogService: DialogService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService,
              private router: Router,
              private snackBarService: SnackBarService) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const dialogModel: DialogModel = DialogModel.create(
      'Add Preset Countries',
      'AddPresetCountriesComponent',
      { },
      '565px',
      '565px'
    );
    // dialogModel.componentFactoryResolver = this.componentFactoryResolver;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        if (res.data.input) {
          command.fieldValues['Title'] = res.data.input.title;
          command.fieldValues['CountryList'] = res.data.input.onSelectedCountries;
          this.executeCommandApi(command, handler);
          if (callback) {
            callback();
          }
        }
      }
    });
    return true;
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  executeCommandApi(command: PlatformCommand, handler: IPlatformToolHandler) {
    console.log(command);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        if (commandResponse.fieldValues['ShowMessage']) {
          this.snackBarService.showError(commandResponse.fieldValues['ShowMessage']);
        }
        console.log('[PlatformFilterHandler] Command Response', commandResponse);
        this.invalidateSubject.invalidate();
        this.fuseSplashScreenService.hide();
      });
    }

  }

  valueChanged($event) {
    console.log($event);
  }

  handleAction($event: any) {
    console.log($event);
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
